<template>
  <b-modal
    :title="
      atividade.descricao +
      ' - Local: ' +
      atividade.local +
      ' - Data: ' +
      moment(atividade.data).format('DD/MM/YYYY')
    "
    v-model="show"
    size="xl"
  >
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE TRABALHOS :::::::::::::::::::::::::::: -->
      <b-table
        ref="tableTrabalho"
        bordered
        hover
        small
        head-variant="light"
        :items="getTrabalhos"
        :fields="fields.trabalho"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button
              class="pt-0 pb-0"
              variant="link"
              @click="editar(data.item)"
            >
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <b-alert :show="isDuplicate" variant="warning"
      >Existem números de SGCQ repetidos na lista.</b-alert
    >

    <trabalho-edit-modal ref="trabalhoEdit" @update="update()" />
    <confirm-modal
      ref="confirmAtividade"
      :descricao="'Deseja realmente executar a atividade ?'"
      @executar="executar()"
    />
    <atividade-print-modal ref="atividadeListPrintModal" />

    <template #modal-footer>
      <b-form inline>
        <b-button class="pl-2 pr-3" variant="secondary" @click="setServico()">
          <b-icon
            icon="arrow-up-right-circle"
            variant="light"
            scale="1.1"
            class="mr-2"
          />Setar Serviço
        </b-button>
        <b-form-input
          id="set-servico"
          type="search"
          size="sm"
          class="m-1 p-1 ml-2"
          placeholder="Descreva o serviço para todos."
          v-model="servico"
        />
      </b-form>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon
          icon="plus-circle"
          variant="light"
          scale="1.1"
          class="mr-2"
        />Adicionar
      </b-button>
      <b-button class="pl-2 pr-3" variant="warning" @click="verificar()">
        <b-icon
          icon="exclamation-triangle-fill"
          variant="light"
          scale="1.1"
          class="mr-2"
        />Executar
      </b-button>
      <b-button variant="primary" @click="imprimir()">
        <b-icon
          icon="printer-fill"
          variant="light"
          scale="1.1"
          class="mr-2"
        />Imprimir
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useAtividadeStore } from "@/stores/AtividadeStore";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import TableFields from "@/tools/TableFields";
import Atividade from "@/models/Avulso";
import Trabalho from "@/models/Trabalho";
import Equipamento from "@/models/Equipamento";
import Servico from "@/models/Servico";
import TrabalhoEditModal from "@/components/modals/atividade/TrabalhoEditModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal";
import AtividadePrintModal from "@/components/modals/atividade/AtividadePrintModal";
import Notificacao from "@/models/Notificacao";

export default {
  name: "TrabalhoListModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      atividade: new Atividade(0, "Nova Atividade", "", new Date(), "", ""),
      trabalho: new Trabalho(0, "", "", "", "", "", "", "", "", ""),
      isDuplicate: false,
      servico: "",
    };
  },

  components: {
    "trabalho-edit-modal": TrabalhoEditModal,
    "confirm-modal": ConfirmModal,
    "atividade-print-modal": AtividadePrintModal,
  },

  methods: {
    adicionar() {
      this.trabalho = new Trabalho(0, "", "", "", "", "", "", "", "", "");
      this.trabalho.atividade = this.atividade;
      this.$refs.trabalhoEdit.call(this.trabalho);
    },

    editar(trabalho) {
      this.trabalho = trabalho;
      this.trabalho.atividade = this.atividade;
      this.$refs.trabalhoEdit.call(this.trabalho);
    },

    imprimir() {
      this.$refs.atividadeListPrintModal.call(this.atividade);
    },

    verificar() {
      this.$refs.confirmAtividade.call();
    },

    setServico() {
      this.getTrabalhos.forEach((trabalho) => {
        trabalho.servico = this.servico;
      });
    },

    executar() {
      this.getTrabalhos.forEach((element) => {
        let equipamento = this.buildEquipamento(element);
        let servico = this.buildServico(element);
        servico.equipamento = equipamento;
        //Adicionou o serviço e atualizou o equipamento
        this.equipamentoStore.CADASTRAR_SERVICO(servico).then(() => {
          this.equipamentoStore.ALTERAR_EQUIPAMENTO(equipamento);
          //Deletar os trabalhos
          this.atividadeStore.REMOVER_TRABALHO(element.id);
        });
      });
      this.store.NOTIFICAR(
        new Notificacao(
          "Serviço adicionado no SGCQ com sucesso!",
          "Excelente!",
          "success"
        )
      );
    },

    buildEquipamento(trabalho) {
      const equipamento = new Equipamento(
        0,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      );
      equipamento.cliente = this.atividade.cliente;
      equipamento.sgcq = trabalho.sgcq;
      equipamento.nome = trabalho.nome;
      equipamento.codigo = trabalho.codigo;
      equipamento.fabricante = trabalho.fabricante;
      equipamento.dimensoes = trabalho.dimensoes;
      equipamento.peso = trabalho.peso;
      equipamento.carga = trabalho.carga;
      equipamento.observacao = trabalho.observacao;
      equipamento.grupo = trabalho.atividade.grupo;
      if (this.atividade.referencia != null) {
        equipamento.referencia = this.atividade.referencia;
      } else {
        equipamento.referencia = "REF-OUTSET";
      }

      equipamento.responsavel = trabalho.atividade.responsavel;
      return equipamento;
    },

    buildServico(trabalho) {
      const servico = new Servico(0, "", new Date(), false, false);
      servico.descricao = trabalho.servico;
      servico.data = trabalho.atividade.data;
      servico.concluido = true;
      return servico;
    },

    update() {
      this.atividadeStore.LISTAR_TRABALHOS(this.atividade.id).then(() => {
        this.trabalho = new Trabalho(0, "", "", "", "", "", "", "", "", "");
        this.testarRepetido();
        this.testarEquipamentos();
      });
    },

    testarEquipamentos() {
      var lista = this.getTrabalhos;
      lista.forEach((element) => {
        let eqp = this.getBySgcq(element.sgcq);
        let changed = false;
        if (eqp[0].nome != element.nome) {
          changed = true;
        }
        if (eqp[0].codigo != element.codigo) {
          changed = true;
        }
        if (eqp[0].fabricante != element.fabricante) {
          changed = true;
        }
        if (eqp[0].dimensoes != element.dimensoes) {
          changed = true;
        }
        if (changed) {
          let index = lista.findIndex((obj) => obj.id == element.id);
          this.atividadeStore.TRABALHO_ALTERADO(index);
          this.$refs.tableTrabalho.refresh();
        }
      });
    },

    testarRepetido() {
      var lista = this.getTrabalhos;
      var valueArr = lista.map(function (item) {
        return item.sgcq;
      });
      this.isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
    },

    call(atividade) {
      this.show = !this.show;
      this.atividade = atividade;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const atividadeStore = useAtividadeStore();
    const { getTrabalhos } = storeToRefs(atividadeStore);
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);

    return {
      store,
      atividadeStore,
      getTrabalhos,
      equipamentoStore,
      getBySgcq,
    };
  },
};
</script>

<style lang="scss" scoped>
#set-servico {
  width: 25rem;
}
</style>
